import React, { useEffect } from 'react'

export default function Textarea({ object, handleFormData, formUse, data, prefilledData, viewOnly,rowIndex, colIndex }) {

    useEffect(() => {
        formUse && handleFormData && handleFormData(object.content+"-"+rowIndex+colIndex, "")
    }, [])

    return (
      <div>
        <label>{object.content}</label>
        <textarea
          className="form-control"
          onChange={(e) =>
            formUse &&
            handleFormData &&
            handleFormData(
              object.content + "-" + rowIndex + colIndex,
              e.target.value
            )
          }
          value={
            prefilledData &&
            prefilledData[object.content + "-" + rowIndex + colIndex]
              ? prefilledData[object.content]
              : data && data[object.content+ "-" + rowIndex + colIndex]
          }
          disabled={
            prefilledData && prefilledData[object?.content + "-" + rowIndex + colIndex]
              ? true
              : viewOnly
              ? viewOnly
              : false
          }
        />
      </div>
    );
}
